import {
  Text,
  Spacer,
  Button,
  Modal,
  Input,
  Dropdown,
  Table,
  Tooltip,
  Progress
} from '@nextui-org/react';
import { useEffect, useState, useRef, Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './Home.module.css';
import { nanoid } from 'nanoid';
import CrawlData from 'components/CrawlData/CrawlData';
import {
  FcCollect,
  FcDeleteDatabase,
  FcFile
} from 'react-icons/fc';
import { TfiImport } from 'react-icons/tfi';
import { FaFileImport } from "react-icons/fa";
import { HiOutlineEye } from 'react-icons/hi';
import { useDropzone } from 'react-dropzone';
import { readJsonFile } from 'services/util/UtilService';
import { download } from 'services/util/UtilService';

const Home = () => {
  const [listCourse, setListCourse] = useState([]);
  const [showImport, setShowImport] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [showModalCrawl, setShowModalCrawl] = useState(false);
  const [selection, setSelection] = useState([]);
  const [isDeleteMode, setIsDeleteMode] = useState(false);

  const codeRef = useRef();
  const navigate = useNavigate();

  const { getRootProps, getInputProps, open, acceptedFiles, inputRef } = useDropzone({
    noClick: true,
    noKeyboard: true
  });

  const getData = useCallback(() => {
    const array = Object.keys(localStorage).map((key) => {
      return { id: key, data: JSON.parse(localStorage.getItem(key)) };
    });

    const t = array.sort((a, b) => {
      return new Date(b.data.createdAt) - new Date(a.data.createdAt);
    })

    setListCourse(t);
  }, [])

  useEffect(() => {
    getData();
  }, []);

  const handleImportModule = () => {
    navigate('/import');
  };

  const handleCreate = () => {
    navigate('/create')
  }

  const handleChangeSelect = (e) => {
    console.log(e);
    setSelection([...e]);
  };

  const handleDelete = () => {
    console.log(selection);
    selection.forEach((item) => {
      localStorage.removeItem(item);
    });
    getData();
    setSelection([]);
    setIsDeleteMode(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getData();
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleImportModuleFromFile = useCallback(async () => {
    if (acceptedFiles.length > 0) {
      for (const file of acceptedFiles) {
        if (file.type === 'application/json' || file.name.endsWith('.json')) {
          try {
            const jsonData = await readJsonFile(file);
            if (Array.isArray(jsonData)) {
              for(const module of jsonData) {
                localStorage.setItem(nanoid(15), JSON.stringify(module))
              }
            } else if (jsonData !== null && typeof jsonData === 'object') {
              localStorage.setItem(nanoid(15), JSON.stringify(jsonData))
            } else {
              console.log("The data is another JSON primitive (e.g., string, number, boolean, or null).");
            }
          } catch (error) {
            console.error(`Error reading file ${file.path}:`, error);
          }
        } else {
          console.log(`Skipping non-JSON file: ${file.path}`);
        }
      }
      
      acceptedFiles.length = 0;
      acceptedFiles.splice(0, acceptedFiles.length);
      inputRef.current.value = '';
      
      getData();
    }
  }, [acceptedFiles])

  const handleExportModulesToFile = () => {
    let modules = [];
    for (const [key, value] of Object.entries(localStorage)) {
      modules.push(JSON.parse(value));
    }
    if (modules.length != 0) {
      download(JSON.stringify(modules), 'LL-Tool Modules.json', 'application/json')
    }
  }

  useEffect(() => {
    handleImportModuleFromFile()
  }, [handleImportModuleFromFile])

  const handleImport = () => {
    const code = codeRef.current.value.trim();

    setIsGettingData(true);
    fetch(
      'https://short-link-adonisgm.azurewebsites.net/api/quizlet/download',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Something went wrong');
      })
      .then((data) => {
        const course = data.data;
        localStorage.setItem(nanoid(15), course);
        setShowImport(false);
        setIsGettingData(false);
        getData();
      })
      .catch(() => {
        setIsFailed(true);
        setIsGettingData(false);
      });
  };

  return (
    <div>
      <CrawlData
        open={showModalCrawl}
        setClose={setShowModalCrawl}
        onSuccess={() => {
          setShowModalCrawl(false);
          getData();
        }}
      />
      <Modal
        open={showImport}
        blur
        closeButton
        onClose={() => {
          setShowImport(false);
        }}
      >
        <Modal.Body>
          <Fragment>
            <Text
              p
              b
              size={14}
              css={{
                textAlign: 'center',
              }}
            >
              Import by share code
            </Text>
            <Spacer y={0.5} />
            <Input placeholder="Share code" ref={codeRef} />
            <Button
              auto
              css={{
                margin: '0 auto',
              }}
              onClick={() => {
                handleImport();
              }}
              disabled={isGettingData}
              color={isFailed ? 'error' : 'primary'}
            >
              Import
            </Button>
          </Fragment>
        </Modal.Body>
      </Modal>
      <div className={classes.header}>
        <Text h1>Home</Text>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            columnGap: '1rem',
          }}
        >
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <Dropdown disableAnimation>
              <Dropdown.Button flat color="secondary">
                Menu
              </Dropdown.Button>
              <Dropdown.Menu
                color="secondary"
                aria-label="Actions"
                css={{ $$dropdownMenuWidth: '280px' }}
                onAction={(e) => {
                  switch (e) {
                    case 'create': 
                      handleCreate();
                      break;
                    case 'quizlet':
                      handleImportModule();
                      break;
                    case 'import':
                      open();
                      //setShowImport(true);
                      //setIsFailed(false);
                      break;
                    case 'allExportModules':
                      handleExportModulesToFile();
                      break;
                    case 'crawl':
                      setShowModalCrawl(true);
                      break;
                    case 'merge':
                      navigate('/merge');
                      break;
                    case 'delete':
                      setIsDeleteMode(!isDeleteMode);
                      setSelection([]);
                    default:
                      break;
                  }
                }}
              >
                
                <Dropdown.Section title="Module management">
                  <Dropdown.Item
                    key="create"
                    description="Create a module as a dictionary"
                    color="success"
                    icon={<FcFile />}
                  >
                    Create module
                  </Dropdown.Item>
                  <Dropdown.Item
                    key="quizlet"
                    description="Importing a module as a table"
                    color="primary"
                    icon={<FcFile />}
                  >
                    Import module
                  </Dropdown.Item>
                
                  <Dropdown.Item
                    key="import"
                    description="Upload JSON file"
                    color="secondary"
                    icon={<FaFileImport />}
                  >
                    Import module from file
                  </Dropdown.Item>
                  <Dropdown.Item
                      key="allExportModules"
                      description="Download modules JSON file"
                      color="primary"
                      icon={<TfiImport size={20} />}
                    >
                      Export all modules
                  </Dropdown.Item>
                  <Dropdown.Item
                    key="merge"
                    description="Merge course for easy learning"
                    color="default"
                    icon={<FcCollect />}
                  >
                    Merge course
                  </Dropdown.Item>
                </Dropdown.Section>
                <Dropdown.Section title="Danger">
                  <Dropdown.Item
                    key="delete"
                    description="Delete selected course"
                    color="error"
                    icon={<FcDeleteDatabase />}
                  >
                    {isDeleteMode ? 'Cancel delete mode' : 'Delete mode'}
                  </Dropdown.Item>
                </Dropdown.Section>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <Spacer y={1.4} />
      <Text
        p
        b
        size={16}
        css={{
          width: '100%',
          textAlign: 'center',
        }}
      >
        List courses
      </Text>
      <Spacer />
      {listCourse.length > 0 && (
        <Table
          selectionMode={isDeleteMode ? 'multiple' : 'none'}
          onSelectionChange={handleChangeSelect}
          color={isDeleteMode ? 'error' : 'primary'}
          selectedKeys={selection}
        >
          <Table.Header>
            <Table.Column>name</Table.Column>
            <Table.Column>quantity</Table.Column>
            <Table.Column>Progress</Table.Column>
            <Table.Column>Progress Listening</Table.Column>
            <Table.Column width={190}>Create at</Table.Column>
            <Table.Column width={40} align={'end'}></Table.Column>
          </Table.Header>
          <Table.Pagination
            shadow
            noMargin
            align="center"
            rowsPerPage={10}
            color={isDeleteMode ? 'error' : 'primary'}
          />
          <Table.Body>
            {listCourse
              .map((item) => {
                const progress = (
                  (item.data.data.filter((item) => {
                    return item.learned;
                  }).length *
                    100) /
                  item.data.data.length
                ).toFixed(2);
                const progressLearning = (
                  (item.data.data.filter((item) => {
                    return item.learnedListening;
                  }).length *
                    100) /
                  item.data.data.length
                ).toFixed(2);
                return (
                  <Table.Row key={item.id}>
                    <Table.Cell>{item.data.name}</Table.Cell>
                    <Table.Cell>{item.data.data.length}</Table.Cell>
                    <Table.Cell>
                      <Text
                        p
                        b
                        color={
                          progress >= 90
                            ? 'success'
                            : progress > 0
                            ? 'warning'
                            : 'error'
                        }
                      >
                        {progress} %
                      </Text>
                      <Progress
                        size={'xs'}
                        value={progress}
                        color={
                          progress >= 90
                            ? 'success'
                            : progress > 0
                            ? 'warning'
                            : 'error'
                        }
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Text
                        p
                        b
                        color={
                          progressLearning >= 90
                            ? 'success'
                            : progressLearning > 0
                            ? 'warning'
                            : 'error'
                        }
                      >
                        {progressLearning} %
                      </Text>
                      <Progress
                        size={'xs'}
                        value={progressLearning}
                        color={
                          progressLearning >= 90
                            ? 'success'
                            : progressLearning > 0
                            ? 'warning'
                            : 'error'
                        }
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {new Date(item.data.createdAt).toLocaleString()}
                    </Table.Cell>
                    <Table.Cell
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {!isDeleteMode && (
                        <Tooltip content={'View detail'}>
                          <HiOutlineEye
                            size={20}
                            color="#005FCC"
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              navigate(`/course/${item.id}`);
                            }}
                          />
                        </Tooltip>
                      )}
                    </Table.Cell>
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      )}
      {selection.length > 0 && (
        <Fragment>
          <Spacer y={1} />
          <Button
            auto
            color="error"
            onClick={() => {
              handleDelete();
            }}
            css={{
              margin: '0 auto',
            }}
          >
            <Text color="#fff">Delete selected</Text>
          </Button>
          <Text
            css={{
              textAlign: 'center',
            }}
            size={12}
            color="error"
          >
            Careful, <b>this action cannot be undone.</b> Gods help you.
          </Text>
        </Fragment>
      )}
    </div>
  );
};

export default Home;
